import { useDeliveryTableData } from '@/context/orders/DeliveryTableFilteredData';
import { processDispensing } from '@/services/pharmacist.service';
import { Logger } from '@/utils/logger';
import { useSelectedOrders } from '@montugroup/circuit-shared/context/table/OrderSelectionContext';
import { Badge, Box, LoadingButton, toast } from '@montugroup/design-system';
import { useState } from 'react';

const logger = new Logger('ProcessDispenseButton');

function ProcessDispenseButton() {
  const { isLoading, refetch } = useDeliveryTableData();
  const [isProcessing, setIsProcessing] = useState(false);
  const selectedOrders = useSelectedOrders();

  const handleDispenseOrders = async () => {
    if (selectedOrders.length === 0) {
      toast.error('Select orders using checkboxes before proceeding with action.');
      return;
    }

    setIsProcessing(true);

    const {
      data: { status, message, pdfUrl },
    } = await processDispensing(Array.from(selectedOrders));

    await refetch();

    if (status) {
      if (!pdfUrl || window.open(pdfUrl) !== null) {
        // When no PDF URL, or opened successfully, just show the standard message.
        toast.success(message);
      } else {
        // On failure to open a window, offer a download link
        toast.success(
          {
            title: message,
            message: <a href={pdfUrl}>Download dispensing document</a>,
          },
          { autoClose: false },
        );
      }
    } else {
      toast.error(message);
      logger.error('dispenseOrders', message);
    }
    setIsProcessing(false);
  };
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'end' }}>
      <Badge badgeContent={selectedOrders.length} color="secondary" showZero>
        <LoadingButton
          variant="contained"
          size="large"
          onClick={handleDispenseOrders}
          loading={isProcessing}
          disabled={isProcessing || isLoading}
          sx={{ width: '12.5rem' }}
        >
          Process dispense
        </LoadingButton>
      </Badge>
    </Box>
  );
}

export default ProcessDispenseButton;
